// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.scss\"","crimsonColor":"#ce3636","smallWidth":"768px","button":"SignupForm_button__d68MN","error":"SignupForm_error__2tzIP"};